import React, { useState, useEffect, useRef} from "react";
import { useHistory, Redirect } from "react-router-dom";
import firebase from 'firebase/app';
import {JsonPretty, ElmentShow, FacebookMessageUs, ContactIcon, ContactIconBar, ContactIconSector, uploadImageDynamicBack} from '../config/projectConfig';

import { Nav, Navbar, NavDropdown, Form, FormControl, Button, ButtonGroup, InputGroup, Modal, Row, Col, CardDeck, Card, Container } from 'react-bootstrap';

import { faGlobe,faHome, faPhoneSquare, faPlus, faPencilAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
import { faLine, faFacebookSquare, faInstagramSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessengerCustomerChat from 'react-messenger-customer-chat';
// import {SocialMediaIconsReact} from 'social-media-icons-react';
// import {loadFbLoginApi} from './FacebookCustomerChat'

import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase';
import { loadMaster, dateFormat, uploadImage, getCol, getColById, getDoc, getDocById ,uploadImageDynamic } from '../config/dbUtils'
import { LabelTextInput, LabelImageInput, TextInput, ImageInput } from '../config/formUtils'

const PageFunction = (props) => {
    const db = firebase.firestore();
    const inputRef = useRef(null);
    const [hideControl, setHideControl] = useState(false);
    const [hideControlInsert, setHideControlInsert] = useState(true);
    
    const [helmet, setHelmet] = useState({}); 
    const [docId,setDocId] = useState(0);
    const [state, setState] = useState([{ url: "" }]);
    const [inputList, setInputList] = useState([
        // { element: "textSector",value:"" }
        // ,{ element: "image",value:"https://firebasestorage.googleapis.com/v0/b/upbrand2/o/images%2Fweget_logo.png?alt=media&token=4404e624-aa23-4bb9-b1d5-fb79933a5548" }
        // ,{ element: "youtube",value:"_9OY4ZDnXn811111" }
    ]);
    const contact = 
        { 
            phone: { contact_id: "02-120-6245", name: "02 120 6245" } 
            ,facebook: { contact_id: "wegetcompany", name: "wegetcompany" } 
            ,line: { contact_id: "@wegetcompany", name: "@wegetcompany" } 
            ,instagram: { contact_id: "wegetcompany", name: "wegetcompany" } 
            ,twitter: { contact_id: "wegetcompany", name: "wegetcompany" } 
            ,youtube: { contact_id: "UCl7HAjgFN3HUZe3KaQmJDSQ", name: "wegetcompany" } 
            ,linkedin: { contact_id: "wegetcompany", name: "wegetcompany" } 
        }
    useEffect(() => {
        //abc    R2HJNz6qOQC8iFo2txpA
        //uni    0bTeaI4tZTJPa2TC7eSs
        //http://localhost:3000/webEdit/abc
        var path =  window.location.href.split('/')[4];
        var path1 = path.split("#")[0];
        var webName = path1.split("/")[0];
        console.log("webName  = ",webName);
        getWebsite(webName);


        // const script = document.createElement("script");
        // script.src = "../FACEBOOK_CUSTOMER.js";
        // script.async = true;
        // document.body.appendChild(script);
    },[]);
    const getWebsite = async (webName) => {
        var result = {};
        var website = db.collection("website");
        website.where("name","==",webName)
        .get().then((snapshot) => {
          snapshot.forEach((doc) => {
            var data = doc.data();
            result = {...result,[doc.id]:data};
            website.doc(doc.id).collection("helmet").get().then((s)=>{
              s.forEach((doc)=>{
                console.log("helmet = >>>>>>>  ", doc.data());
                setHelmet(doc.data());
              })
            })
          });
          console.log("result = ",JSON.stringify(result));
          Object.keys(result).forEach((key)=>{
            var idDynamic = result[key].element;
            getDynamicDocById(idDynamic);
          })
        });
      }
      const getDynamicDocById = (key) => {
        db.collection("dynamic")
        .doc(key)
        .get().then((doc) => {
            var data = doc.data();
            setDocId(doc.id);
            // console.log("aaaaaa =", inputList );
            // console.log("aaaaaa =", data.inputList );
            // setInputList(...inputList, data.inputList);
            setInputList(data.inputList);
        })
      }
      
    const onSubmit = (e) => {
        console.log("inputList = ", inputList);
        db.collection("dynamic").add({
            inputList
        }).then((docRef) => {
          setState({
            list: ''
          });
        //   this.props.history.push("/dynamic")
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
      }
    const onSubmitUpdate = (e) => {
        console.error("Error docId document: ", docId);
        const updateRef = db.collection('dynamic').doc(docId);
        updateRef.set({
            inputList   
        }).then((docRef) => {
          this.setState({
            key: '',
            list: '',
          });
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
        alert('save แล้วนะ');
    }
    const history = useHistory();
    const onPreview = (e) => {
        var webName = window.location.href.split('/')[4];
        // history.push('/web/'+docId);
        history.push('/web/'+webName);
    }
    // handle input change
    const handleInputChange = (key, value, index) => {
        const list = [...inputList];
        list[index][key] = value;
        setInputList(list);
    };
    const updateMenu = (name, path) =>{
        if(name && name!="" && path && path!="")
        setMenu(...menu, {name:path});
    }
    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };
    const handleAddElementClick = (type, index) => {
        if(index){
            var i = index+1;
            var array = [...inputList];
            array.splice(i,0,{ element: type, value: "" });
            setInputList(array);
            setIndexOfSelected(i);
            handleShow();
        }else{
            setInputList([...inputList, { element: type, value: "" }]);
            setIndexOfSelected(inputList.length);
            handleShow();
        }
        setTimeout(() => {
            inputRef.current.focus();
        }, 1);
    }

    const handleUploadImage = (image,index) => {
        uploadImage(null,null,'images',image,index);
    };
    const uploadImage = (taskCreate, setTaskCreate, path, image, index) => {
        if(image){
            const storage = firebase.storage();
            const uploadTask = storage.ref(`${path}/${image.name}`).put(image);
            uploadTask.on(
                "state_changed",
                snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                },
                error => {
                // Error function ...
                console.log(error);
                },
                () => {
                // complete function ...
                storage
                    .ref(path)
                    .child(image.name)
                    .getDownloadURL()
                    .then(url => {
                        console.log("url = ",url);
                        // setTaskCreate({ ...taskCreate, image: url });
                        console.log("index = ",index);
                        if(index){
                            inputList[index].value = url;  
                            setInputList(inputList);
                        }
                        else
                            setInputList([...inputList, { element: "image", value: url }]);
                    });
                }
            );
        }
    };
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [indexOfSelected, setIndexOfSelected] = useState(0);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
      
    const BtnUpdateDelete = (props) => {
        var i = props.i;
        var item = props.item;
        return (<>
            <Button type="button" style={{zIndex:"100", position:"absolute",right:"45px"}} className="btn-warning" hidden={hideControl}
                onClick={() => {setIndexOfSelected(i);handleShow();}}><FontAwesomeIcon icon={faPencilAlt}/> </Button>
            <Button type="button" style={{zIndex:"100", position:"absolute",right:"0"}} className="btn-danger" hidden={hideControl}
                onClick={() => {if(window.confirm('Delete the item?')){handleRemoveClick(i)}}} ><FontAwesomeIcon icon={faTrash}/> </Button>
        </>)
    }

    
    const projectName = "";
    const menuData = [
        {
            name: 'Home',
            path: '#home'
        },
        {
            name: 'Our Product',
            path: '#product'
        },
        {
            name: 'About Us',
            path: '#about'
        },
        {
            name: 'Contact Us',
            path: '#contact'
        }
    ];
    const [menu,setMenu] = useState(menuData);
    const [uploadResult,setUploadResult] = useState();
    const imgChange = (key,value,index,path) => { 
        console.log("imgChange("+key+","+value+","+index+","+path+")"); 
        uploadImageDynamicBack(uploadResult, setUploadResult, key, value, path); 
        console.log("return URL",uploadResult);
        var temp = inputList;
        temp[index]={};
        temp[index]["value"]={};
        console.log("Temp ... ",temp[index]["value"]);
        temp[index]["value"]["image1"] = uploadResult;
        temp[index]["text"]="test";
        setInputList(inputList)
        
        // inputList[index].value[image1] = url;  
        // setInputList(inputList);
    };
      return (
        <div className="App" >   
            <div>
                <Modal show={show} onHide={handleClose} onChange={(e) =>inputRef} 
                  {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >
                  <Modal.Header closeButton> 
                    <Modal.Title>Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{textAlign: "center"}}>
                        <ElmentShow i={indexOfSelected} 
                            item={inputList[indexOfSelected]} 
                            noFullWidth={inputList[indexOfSelected] && inputList[indexOfSelected].noFullWidth ? true :false} 
                            link={inputList[indexOfSelected] && inputList[indexOfSelected].link ? true :false} />
                    </div>
                    <hr/>

{/* Card Image */}
                    { inputList[indexOfSelected] && inputList[indexOfSelected].element === "cardDeck"
                    ?
                    // <ImageInput as={Row} label="Compa1" name="companyIcon" path="images" value={doc} event={imgChange} />
                    <ImageInput as={Row} label="Image1" name="companyLogo" path="images" value={inputList[indexOfSelected].value.image1} event={imgChange} index={indexOfSelected} />
                    // <label htmlFor="editimage1" >
                    //     <span className="btn btn-primary"><FontAwesomeIcon icon={faPlus} /> Upload an new Image </span>
                    //     <input id="editimage1" type="file" className="btn btn-primany" style={{ display: "none" }} onChange={ e => e.target.files[0] ? handleUploadImage(e.target.files[0],indexOfSelected) : ""} />
                    // </label>
                    :""
                    }
{/* Image */}
                    { inputList[indexOfSelected] && inputList[indexOfSelected].element === "image"
                    ?
                    <label htmlFor="editimage1" >
                        <span className="btn btn-primary"><FontAwesomeIcon icon={faPlus} /> Upload an new Image </span>
                        <input id="editimage1" type="file" className="btn btn-primany" style={{ display: "none" }} onChange={ e => e.target.files[0] ? handleUploadImage(e.target.files[0],indexOfSelected) : ""} />
                    </label>
                    :""
                    }
                    <Form.Group as={Row} >
                        <Form.Label column sm="2"> Text </Form.Label>
                        <Col sm="10">
                            <FormControl name="value" className="control-input" ref={inputRef} 
                                value={inputList[indexOfSelected] && inputList[indexOfSelected].value ? inputList[indexOfSelected].value : ''} 
                                onChange={e => handleInputChange(e.target.name, e.target.value, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} >
                        <Form.Label column sm="2"> Link </Form.Label>
                        <Col sm="10">
                            <FormControl name="link" className="control-input" 
                                value={inputList[indexOfSelected] && inputList[indexOfSelected].link ? inputList[indexOfSelected].link : ''} 
                                onChange={e => handleInputChange(e.target.name, e.target.value, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    <hr/>
                    <Form.Group as={Row} >
                        <Col sm="5">
                        <Form.Check type="checkbox" label="Not Full Width" 
                            checked={inputList[indexOfSelected] && inputList[indexOfSelected].noFullWidth ? inputList[indexOfSelected].noFullWidth : ''} 
                            onChange={e => handleInputChange('noFullWidth', e.target.checked ? true : false, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} >
                        <Col sm="5">
                        <Form.Check type="checkbox" label="Align Left" 
                            checked={inputList[indexOfSelected] && inputList[indexOfSelected].alignLeft ? inputList[indexOfSelected].alignLeft : ''} 
                            onChange={e => handleInputChange('alignLeft', e.target.checked ? true : false, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    {/* <Form.Group as={Row} >
                        <Col sm="5">
                        <Form.Check type="checkbox" label="Bold" 
                            checked={inputList[indexOfSelected] && inputList[indexOfSelected].bold ? inputList[indexOfSelected].bold : ''} 
                            onChange={e => handleInputChange('bold', e.target.checked ? true : false, indexOfSelected)} />
                        </Col>
                    </Form.Group> */}
                    <Form.Group as={Row} >
                        <Col sm="5">
                        <Form.Check type="checkbox" label="Underline" 
                            checked={inputList[indexOfSelected] && inputList[indexOfSelected].underline ? inputList[indexOfSelected].underline : ''} 
                            onChange={e => handleInputChange('underline', e.target.checked ? true : false, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} >
                        <Form.Label column sm="2"> color </Form.Label>
                        <Col sm="5">
                        <FormControl name="color" className="control-input" 
                                value={inputList[indexOfSelected] && inputList[indexOfSelected].color ? inputList[indexOfSelected].color : ''} 
                                onChange={e => handleInputChange(e.target.name, e.target.value, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    <hr/>
                    Menu
                    <Form.Group as={Row} >
                        <Form.Label column sm="2"> Menu ID </Form.Label>
                        <Col sm="3">
                            <FormControl name="menuLink" className="control-input" 
                            value={inputList[indexOfSelected] && inputList[indexOfSelected].menuLink ? inputList[indexOfSelected].menuLink : ''} 
                            onChange={e => handleInputChange(e.target.name, e.target.value, indexOfSelected)} />
                        </Col>
                        <Form.Label column sm="2"> Menu Name </Form.Label>
                        <Col sm="5">
                            <FormControl name="menuName" className="control-input" 
                            value={inputList[indexOfSelected] && inputList[indexOfSelected].menuName ? inputList[indexOfSelected].menuName : ''} 
                            onChange={e => handleInputChange(e.target.name, e.target.value, indexOfSelected)} />
                        </Col>
                    </Form.Group>
                    {/* <input type="text"  name="value" value={inputList[selectedIteam].value} onChange={(e)=>{handleInputChangeFromModal(e.target.name, e.target.value ,selectedIteam)} } /> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}> Close </Button>
                    {/* <Button variant="primary" onClick={handleClose}> Save Changes </Button> */}
                </Modal.Footer>
            </Modal>
            <div>
            {inputList.map((item, i) => {
                return(
                    <>
                        {item["element"] && item["element"] != "" 
                        ?  <div key={i} >
                            <BtnUpdateDelete i={i} item={item} />
                            <ElmentShow i={i} item={item} />
                            <ButtonGroup size="sm" >
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('textSector',i)}}><FontAwesomeIcon icon={faPlus}/> Sector</Button>
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('textTitle',i)}}><FontAwesomeIcon icon={faPlus}/> Title</Button>
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('textMessage',i)}}><FontAwesomeIcon icon={faPlus}/> Message</Button>
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('text',i)}}><FontAwesomeIcon icon={faPlus}/> Text</Button>
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('image',i)}}><FontAwesomeIcon icon={faPlus}/> Image</Button>
                                <Button variant="secondary" hidden={hideControlInsert} onClick={(e)=>{handleAddElementClick('youtube',i)}}><FontAwesomeIcon icon={faPlus}/> Youtube</Button>
                            </ButtonGroup>
                        </div>
                        :<></>
                        }
                    </>
                );
            })}
            <div hidden={hideControl}>
                <hr/>
                <ButtonGroup aria-label="Basic example">
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('textSector',)}}><FontAwesomeIcon icon={faPlus}/> Sector</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('textTitle',)}}><FontAwesomeIcon icon={faPlus}/> Title</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('textMessage',)}}><FontAwesomeIcon icon={faPlus}/> Message</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('text',)}}><FontAwesomeIcon icon={faPlus}/> Text</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('image',)}}><FontAwesomeIcon icon={faPlus}/> Image</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('youtube',)}}><FontAwesomeIcon icon={faPlus}/> Youtube</Button>
                    <Button variant="success" size="sm" hidden={hideControl} onClick={(e)=>{handleAddElementClick('cardDeck',)}}><FontAwesomeIcon icon={faPlus}/> CardDeck</Button>
                </ButtonGroup>
                {/* <img src={taskCreate.image ? taskCreate.image : "appDefault/600x600.webp"  } alt="Uploaded Images" style={{maxHeight:"300px",maxWidth:"300px"}} /> */}
                {/* <label htmlFor="newimage1" >
                    <span className="btn btn-sm btn-success"><FontAwesomeIcon icon={faPlus} /> New Image </span>
                    <input id="newimage1" type="file" className="btn btn-primany" style={{ display: "none" }} onChange={ e => e.target.files[0] ? handleUploadImage(e.target.files[0]) : ""} />
                </label> */}
                <hr/>
                <ButtonGroup className="">
                    <Button variant="primary" onClick={() => onSubmit()}> Save New </Button>
                    <Button variant="primary" hidden={hideControl} onClick={() => onSubmitUpdate()}> Save Update </Button>
                    <Button variant="primary" hidden={hideControl} onClick={() => onPreview()}> Preview </Button>
                    <Button variant="danger" hidden={hideControl} onClick={() => setInputList([])}> Clear </Button>
                </ButtonGroup>
                
                <br/>
                <hr/>
            </div>
            <ContactIconBar contact={ contact } />
            <Form.Check type="checkbox" name="hideBtn" label="Hide Control" style={{textAlign:"left",marginLeft:"15px"}}
                onChange={e => setHideControl(e.target.checked ? true : false)} />
            <Form.Check type="checkbox" name="hideBtn" label="Hide Insert" style={{textAlign:"left",marginLeft:"15px"}}
                onChange={e => setHideControlInsert(e.target.checked ? true : false)} />
            <div hidden={hideControl}>
                {/* [`level${selectedItem.Level + 1}`] */}
                <JsonPretty style={{textAlign:"left"}} data={inputList}></JsonPretty>
                {/* this.setState({["level" + (selectedItem.Level+1)]: FilteredListFromClick}) */}
                {/* <JsonPretty style={{textAlign:"left"}} data={[("inputList")]}></JsonPretty> */}
            </div>
        </div>
    </div>  
    {/* <CustomChat pageId="" />     */}
    <MessengerCustomerChat
        pageId="306725926676739"
        // appId="306725926676739"
        // htmlRef="<REF_STRING>"
    />
      {/* <div id="fb-root"></div>
      {
      <script>
        window.fbAsyncInit = function() {
          FB.init({
            xfbml            : true,
            version          : 'v8.0'
          });
        };

        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));</script>
}
      <div class="fb-customerchat"
        attribution=setup_tool
        page_id="306725926676739">
      </div> */}


</div>
    );
}
class Page extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      return (
          <PageFunction {...this.props} firebase={this.props.firebase} />
      );
    }
  }
  
  export default withFirebase(Page);